export default "__VITE_ASSET__CAS$$IgD__"